import React from 'react';
import { useNavigate } from 'react-router-dom';

const BotonVolver = ({ ruta = '/admin/dashboard' }) => {
  const navigate = useNavigate();

  return (
    <button 
      onClick={() => navigate(ruta)}
      className="
        flex items-center gap-2 px-5 py-2.5 
        bg-white border border-gray-300 rounded-xl 
        text-gray-600 font-semibold text-sm
        transition-all duration-300 ease-in-out
        shadow-sm
        hover:border-blue-400 hover:text-blue-600
        hover:bg-blue-50 
        hover:shadow-[0_0_15px_rgba(59,130,246,0.3)] 
      "
    >
      <span>⬅</span> Volver
    </button>
  );
};

export default BotonVolver;